package org.hs_soft.runmynesto.domain.model.home.template.tabs.tab_general.calendar

data class YearModel(
    val monthsOfYear:List<MonthModel>
)